import { Component } from 'react';
import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('[ErrorBoundary]', error);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className='min-h-screen bg-background flex items-center justify-center px-6'>
        <div className='max-w-md w-full text-center'>
          <p className='text-xs text-muted-foreground uppercase tracking-widest mb-2'>Ошибка</p>
          <h1
            className='text-4xl font-bold text-foreground mb-4'
            style={{ fontFamily: '"Dela Gothic One", sans-serif' }}
          >
            Что-то пошло не так
          </h1>
          <p className='text-sm text-muted-foreground mb-2'>
            Произошла непредвиденная ошибка. Попробуйте обновить страницу.
          </p>
          <p className='text-xs text-muted-foreground/60 font-mono mb-8 break-all'>
            {error.message}
          </p>
          <Button onClick={() => window.location.reload()}>Обновить страницу</Button>
        </div>
      </div>
    );
  }
}
